import { lazy, Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Layout from './components/layout/Layout';
import { hertzTheme, ThemeProvider } from "@revlab/highlander-ui";
import { CssBaseline, CircularProgress, Box } from '@mui/material';
import { AuthProvider } from './auth/AuthProvider';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AuthRoute from './components/auth/AuthRoute';
import { Provider } from 'react-redux';
import { store } from './store/store';

// Lazy load components
const Homepage = lazy(() => import('./components/Homepage').then(module => ({ default: module.Homepage })));
const CreateTransactionPage = lazy(() => import('./components/features/transactions/CreateTransactionPage').then(module => ({ default: module.CreateTransactionPage })));
const QRCodeTransactionPage = lazy(() => import('./components/features/transactions/QRCodeTransactionPage').then(module => ({ default: module.QRCodeTransactionPage })));
const PaymentPage = lazy(() => import('./components/features/transactions/PaymentPage'));
const PaymentComplete = lazy(() => import('./components/features/transactions/PaymentComplete').then(module => ({ default: module.PaymentComplete })));
const PaymentExpired = lazy(() => import('./components/features/transactions/PaymentExpired'));

const router = createBrowserRouter([
  {
    path: "payment",
    element: <PaymentPage />
  },
  {
    path: "payment-complete",
    element: <PaymentComplete />
  },
  {
    path: "payment-expired",
    element: <PaymentExpired />
  },
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/oauth2/callback",
        element: <ProtectedRoute><Homepage /></ProtectedRoute>
      },
      {
        path: "/",
        element: <AuthRoute><Homepage /></AuthRoute>
      },
      {
        path: "create-transaction",
        element: <ProtectedRoute><CreateTransactionPage /></ProtectedRoute>
      },
      {
        path: "qr-code-transaction",
        element: <ProtectedRoute><QRCodeTransactionPage /></ProtectedRoute>
      },

    ]
  }
], {
  future: {
    v7_relativeSplatPath: true
  }
});

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={hertzTheme}>
        <CssBaseline />
        <AuthProvider>
          <Suspense fallback={
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
              <CircularProgress />
            </Box>
          }>
            <RouterProvider router={router} />
          </Suspense>
        </AuthProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;